import React from "react";
import { Alert } from "reactstrap";

/**
 * Readable message for a failed learning-path request (create, save, publish, delete).
 * Uses the API's own message when there is one, and explains network/server failures.
 */
export function learningPathErrorMessage(error, fallback) {
  const response = error?.response;
  if (!response) {
    return "Couldn't reach the server. Check your connection (and that the API is running), then try again.";
  }
  const { status, data } = response;
  if (status === 401 || status === 403) return "Your session has expired. Please sign in again.";
  if (status === 404) return data?.message || "This learning path no longer exists. It may have been deleted.";
  const message = data?.message;
  const missingIds = data?.data?.curriculumIds;
  if (Array.isArray(missingIds) && missingIds.length) {
    return `${message || "Some curricula don't exist"} (curriculum ID${missingIds.length > 1 ? "s" : ""}: ${missingIds.join(", ")}). Remove those steps and save again.`;
  }
  if (status >= 500) return `${fallback} The server returned an error (${status}). Please try again.`;
  return message || fallback;
}

/** Dismissible inline error shown next to the action that failed. */
export function LearningPathErrorAlert({ message, onDismiss, className = "" }) {
  return (
    <Alert color="danger" isOpen={!!message} toggle={onDismiss} className={className} fade={false}>
      <i className="mdi mdi-alert-circle-outline me-2" />
      {message}
    </Alert>
  );
}
